export const MAINTENANCE_MODE = "MaintenanceMode";
export const MAINTENANCE_MODE_DESCRIPTION = "MaintenanceModeDescription";
export const VERSION_UPGRADE_MESSAGES = "VersionUpgradeMessages";
export const MINIMUM_VERSION_NUMBER = "MinimumVersionNumber";
